import { MediaTypes } from "@coworker/app/src/components/RoomSettings/constants";
import { getMediaTypeText } from "@coworker/app/src/components/RoomSettings/tools";
import { MediasAndArticleCountResponse } from "@coworker/app/src/components/RoomSettings/types/media";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import useTranslation from "../../../../../../packages/locales/translations/util/useTranslation";

interface MediaSelectionKey {
  mediaId: string;
  articleId: string;
}

interface MediaPlacementsListViewProps {
  groupedMediasByType: Record<string, MediasAndArticleCountResponse[]>;
  showCheckBox?: boolean;
  selectedMediaIds?: MediaSelectionKey[];
  onMediaSelectionChange?: (selectedIds: MediaSelectionKey[]) => void;
}

export const MediaPlacementsListView = ({
  groupedMediasByType,
  showCheckBox = false,
  selectedMediaIds = [],
  onMediaSelectionChange,
}: MediaPlacementsListViewProps) => {
  const { t } = useTranslation();

  const isSelected = (mediaId: string, articleId: string): boolean =>
    selectedMediaIds.some(
      (key) => key.mediaId === mediaId && key.articleId === articleId
    );

  const handleSelectionChange = (
    mediaId: string,
    articleId: string,
    isChecked: boolean
  ) => {
    if (!onMediaSelectionChange) return;
    if (isChecked) {
      onMediaSelectionChange([...selectedMediaIds, { mediaId, articleId }]);
    } else {
      onMediaSelectionChange(
        selectedMediaIds.filter(
          (key) => !(key.mediaId === mediaId && key.articleId === articleId)
        )
      );
    }
  };
  return (
    <>
      {Object.entries(groupedMediasByType).map(
        ([mediaType, mediaAndArticleCounts]) => (
          <FixaListView key={mediaType} id={`media-type-${mediaType}`}>
            <FixaListViewItem
              size="small"
              description={getMediaTypeText(mediaType as MediaTypes)}
              key={`${mediaType}-header`}
            />
            {mediaAndArticleCounts.map((mediaAndArticleCount) => (
              <FixaListViewItem
                key={`${mediaAndArticleCount.mediaId}-${mediaAndArticleCount.groupId}-${mediaAndArticleCount.articleId}`}
                size="medium"
                title={
                  <FixaText textStyle="Heading.S">
                    {mediaType === MediaTypes.ROOM &&
                    mediaAndArticleCount.parentMediaName
                      ? mediaAndArticleCount.parentMediaName
                      : mediaAndArticleCount.name}
                  </FixaText>
                }
                description={
                  <FixaText textStyle="Body.M">
                    {mediaType === MediaTypes.ROOM &&
                    mediaAndArticleCount.parentMediaName
                      ? `${mediaAndArticleCount.name}${mediaAndArticleCount.groupName ? ` > ${mediaAndArticleCount.groupName}` : ""}`
                      : mediaAndArticleCount.groupName}
                  </FixaText>
                }
                quantityLabel={
                  <FixaText textStyle="Body.M">
                    {t("piecesCountString", {
                      count: mediaAndArticleCount.nbrArticles,
                    })}
                  </FixaText>
                }
                control={showCheckBox ? "checkbox" : undefined}
                onChange={
                  showCheckBox
                    ? () =>
                        handleSelectionChange(
                          mediaAndArticleCount.mediaId,
                          mediaAndArticleCount.articleId,
                          !isSelected(
                            mediaAndArticleCount.mediaId,
                            mediaAndArticleCount.articleId
                          )
                        )
                    : undefined
                }
                controlProps={
                  showCheckBox
                    ? {
                        checked: isSelected(
                          mediaAndArticleCount.mediaId,
                          mediaAndArticleCount.articleId
                        ),
                        value: `${mediaAndArticleCount.mediaId}-${mediaAndArticleCount.articleId}`,
                      }
                    : undefined
                }
              ></FixaListViewItem>
            ))}
          </FixaListView>
        )
      )}
    </>
  );
};
